import React from 'react';
import PropTypes from 'prop-types';

const Line = ({ stroke = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="2"
    viewBox="0 0 56 2"
    fill="none"
  >
    <line
      x1="1"
      y1="1"
      x2="55"
      y2="1"
      stroke={stroke || 'var(--SECONDARY_LIGHTER)'}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

Line.propTypes = {
  stroke: PropTypes.string,
};

export default Line;
